import * as actionTypes from "./actionTypes";

export const setFilterCountryID = (id, name) => ({
  type: actionTypes.SELECTED_FILTER_ID,
  id,
  name,
});

export const fetchAllClientApis = () => ({
  type: actionTypes.FETCH_ALL_CLIENT_APIS,
});

export const fetchAllClientApisFailed = () => ({
  type: `${actionTypes.FETCH_ALL_CLIENT_APIS}_FAILED`,
});

export const getDocumentsBySection = (id, from, isNewDocVersionCreated) => ({
  type: actionTypes.GET_DOCUMENT_BY_SECTION,
  payload: id,
  from,
  isNewDocVersionCreated,
});
export const getDocumentsBySectionSuccess = (payload, from) => ({
  type: `${actionTypes.GET_DOCUMENT_BY_SECTION}_SUCCESS`,
  payload,
  from,
});
export const getDocumentsBySectionFailed = (from) => ({
  type: `${actionTypes.GET_DOCUMENT_BY_SECTION}_FAILED`,
  from,
});

export const fetchMetricsData = (payload) => ({
  type: actionTypes.FETCH_METRICS_DATA,
  payload,
});

export const fetchMetricsDataSuccess = (payload) => ({
  type: `${actionTypes.FETCH_METRICS_DATA}_SUCCESS`,
  payload,
});

export const fetchMetricsDataFailed = () => ({
  type: `${actionTypes.FETCH_METRICS_DATA}_FAILED`,
});

export const removeInvalidDocument = (payload) => ({
  type: actionTypes.REMOVE_INVALID_DOCUMENT,
  payload,
});

export const getRoleListSuccess = (payload) => ({
  type: `${actionTypes.GET_ROLE_LIST}_SUCCESS`,
  payload,
});

export const getStudyInfoSuccess = (payload) => ({
  type: `${actionTypes.GET_STUDY_INFO}_SUCCESS`,
  payload,
});

export const getUserInfoSuccess = (payload) => ({
  type: `${actionTypes.GET_USER_INFO}_SUCCESS`,
  payload,
});

export const getUserListSuccess = (payload) => ({
  type: `${actionTypes.GET_USER_LIST}_SUCCESS`,
  payload,
});

export const getOrgId = (payload) => ({
  type: `${actionTypes.GET_ORG_ID}_SUCCESS`,
  payload,
});

export const goToBrowserView = (payload) => ({
  type: actionTypes.GO_TO_BROWSER_VIEW,
  payload,
});

export const getAppInitConfigSuccess = (payload) => ({
  type: `${actionTypes.GET_APP_INIT_CONFIG}_SUCCESS`,
  payload,
});

export const getCountrySiteListSuccess = (payload) => ({
  type: `${actionTypes.GET_COUNTRY_SITE_LIST}_SUCCESS`,
  payload,
});

export const getDocumentsByArtifact = (id, fileguid) => ({
  type: actionTypes.GET_DOCUMENT_BY_ARTIFACT,
  payload: id,
  fileguid
});

export const getDocumentsByArtifactSuccess = (payload, fileguid) => ({
  type: `${actionTypes.GET_DOCUMENT_BY_ARTIFACT}_SUCCESS`,
  payload,
  fileguid
});

export const getDocumentsByArtifactFailed = () => ({
  type: `${actionTypes.GET_DOCUMENT_BY_ARTIFACT}_FAILED`,
});

export const fetchZoneData = () => ({ type: actionTypes.FETCH_ZONE_DATA });
export const zoneDataFetchSuccess = (payload) => ({
  type: `${actionTypes.FETCH_ZONE_DATA}_SUCCESS`,
  payload,
});


export const filterDocuments = (payload) => ({
  type: actionTypes.FILTER_DOCUMENTS,
  payload
});

export const removeArtifact = (payload) => ({
  type: actionTypes.ARTIFACT_REMOVED,
  payload
});

export const removeArtifactItem = (payload) => ({
  type: actionTypes.ARTIFACT_ITEM_REMOVED,
  payload
});
export const showZoneLoader = () => ({
  type: actionTypes.SHOW_ZONE_LOADER,
})

export const hideZoneLoader = () => ({
  type: actionTypes.HIDE_ZONE_LOADER,
})

export const toPassModifiedData = (payload, ismodifiedDocument = false) => ({
  type: actionTypes.TO_PASS_MODIFIED_FILE_DATA,
  payload,
  ismodifiedDocument
});

export const cancelDocId = (payload) => ({
  type: actionTypes.CANCEL_DOC_ID,
  payload
});

export const getRecordState = (payload) => ({
  type: actionTypes.RECORD_STATE,
  payload
});

export const setDocNewVersionXfdfString = (payload) => ({
  type: actionTypes.DOC_NEW_VERSION_XFDF_STRING,
  payload,
})

export const isUploadedNewVersionFile = (payload) => ({
  type: actionTypes.UPLOADED_NEW_VERSION_FILE,
  payload
});

export const clearDocumentList = () => ({
  type: actionTypes.CLEAR_DOCUMENT_DATA_LIST
})
